import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// 1. ellipsis - V
// 2. add ellipsis props - V
// 3. add design - V
// 4. add design props - V
// 3. pass all possible props to ellipsis wrapper - V
// 5. add responsive deign - V
// 6. set api table with proper description - V
// 7. set default props values - V
// 5. add validation on design props with fallback and default values - V
// 6. add disabled design and review all props in Zeplin spec to make sure we are all covered - V
// 7. add storybook examples - V
// 5. add playground props - V
// 9. add deprecation message in the HeadingLabel component - V
// 6. add visual tests - V
// 8. do all this list again for for Heading
// 10. ask for ux approval
// 11. pass lint locally
// 3. check for warnings
// 10. check for warnings in all modified code
// 11. add to backlog 2 new tasks - 1. migrating headingLabel usages. 2. modify component font changes by Zohar's list
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TooltipOnEllipsis from '../tooltipOnEllipsis';
import { dataHooks } from './constants';
var validValues = {
  appearances: {
    options: ['h1', 'h2', 'h3', 'h4', 'h5'],
    defaultValue: 'h1'
  }
}; // const ellipsisPropsNames = [
//     'closeOnMouseClick',
//     'contentClassName',
//     'customTrigger',
//     'customTooltipMessage',
//     'displayCustomTrigger',
//     'marginTop',
//     'marginLeft'
// ]

var Heading = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Heading, _React$PureComponent);

  var _super = _createSuper(Heading);

  function Heading(props) {
    var _this;

    _classCallCheck(this, Heading);

    _this = _super.call(this, props);

    _this.getValidAppearance = function (appearanceRaw) {
      var appearance = appearanceRaw.toLowerCase();
      return validValues.appearances.options.includes(appearance) ? appearance : validValues.appearances.defaultValue;
    };

    return _this;
  }

  _createClass(Heading, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          light = _this$props.light,
          dataHook = _this$props.dataHook,
          appearance = _this$props.appearance,
          translateIfNeeded = _this$props.translateIfNeeded,
          multiline = _this$props.multiline;
      var validAppearance = this.getValidAppearance(appearance);
      var lighterColor = light ? 'light' : '';
      var content = translateIfNeeded(children);
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: "control-heading ".concat(validAppearance, " ").concat(lighterColor)
      }, /*#__PURE__*/React.createElement(TooltipOnEllipsis, {
        dataHook: dataHooks.text,
        maxLines: multiline ? 999 : 1
      }, content));
    }
  }]);

  return Heading;
}(React.PureComponent);

Heading.displayName = displayNames.HEADING;
Heading.propTypes = {
  /** The actual text to be rendered */
  children: PropTypes.string,

  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Font size of the heading */
  appearance: PropTypes.oneOf(validValues.appearances.options),

  /** Set heading with lighter color - effect `standard` and `secondary` skins only */
  light: PropTypes.bool,

  /** Allow multiline heading*/
  multiline: PropTypes.bool
};
Heading.defaultProps = {
  dataHook: 'Heading',
  appearance: validValues.appearances.defaultValue,
  light: false,
  multiline: false
};
export default compose(Heading);